import React from 'react'
import './Terms-of-Service.css'

export default function TermsOfService() {
  return (
    <div className="tos-page">
      <header className="tos-header">
        <h1 className="tos-header__title">Terms &amp; Conditions</h1>
      </header>

      <main className="tos-content-wrap">
        <article className="tos-content">
          <p className="tos-updated">Last Updated: 2026</p>

          <h2>Acceptance of Terms</h2>
          <p>
            By accessing Leadszora, you agree to these Terms &amp; Conditions.
            If you do not agree with any part of these terms, you must not use
            this platform.
          </p>

          <h2>Use of the Platform</h2>
          <p>You may:</p>
          <ul>
            <li>Search and access company information for business research purposes</li>
            <li>Use the platform strictly for business purposes</li>
            <li>Access purchased data according to your subscription plan</li>
          </ul>

          <p>You may NOT:</p>
          <ul>
            <li>Resell or redistribute raw data</li>
            <li>Use data for illegal or unethical activities</li>
            <li>Misuse private or sensitive information</li>
            <li>Attempt to hack, abuse, or disrupt the platform</li>
          </ul>

          <h2>Accounts</h2>
          <p>You are responsible for:</p>
          <ul>
            <li>Keeping your login credentials secure</li>
            <li>All activity performed through your account</li>
          </ul>
          <p>
            We reserve the right to suspend or terminate accounts involved in
            misuse, abuse, or violations of these terms.
          </p>

          <h2>Payments &amp; Billing</h2>
          <ul>
            <li>
              Lifetime access refers to access for the lifetime of the product
              as long as it is actively maintained and supported by Leadszora,
              without guarantee of perpetual availability.
            </li>
          </ul>

          <h2>Disclaimer of Liability</h2>
          <p>Leadszora provides data on an &ldquo;as-is&rdquo; basis. We do not guarantee:</p>
          <ul>
            <li>100% contact data accuracy</li>
            <li>100% mobile number deliverability</li>
            <li>Any specific business outcomes or revenue</li>
          </ul>
          <p>
            You are solely responsible for how you use the data obtained from
            the platform.
          </p>

          <h2>User Responsibility for Data Usage</h2>
          <p>
            Users are solely responsible for ensuring that their use of data
            obtained through Leadszora complies with all applicable laws,
            including but not limited to digital marketing regulations, data
            protection laws, and anti-spam regulations in their respective
            jurisdictions.
          </p>

          <h2>Service Availability</h2>
          <p>
            We do not guarantee uninterrupted or error-free access to the
            platform. Temporary service interruptions may occur due to
            maintenance, system updates, server downtime, or other technical
            issues beyond our control.
          </p>

          <h2>Termination</h2>
          <p>We may terminate or restrict access to accounts involved in:</p>
          <ul>
            <li>Fraud</li>
            <li>Abuse of the platform</li>
            <li>Violation of these terms</li>
            <li>Illegal activities</li>
          </ul>

          <h2>Governing Law</h2>
          <p>
            These Terms &amp; Conditions are governed and interpreted in
            accordance with the laws of India, without regard to conflict of law
            principles.
          </p>

          <h2>Modification of Terms</h2>
          <p>
            We reserve the right to modify or update these Terms &amp;
            Conditions at any time. Continued use of the platform after any such
            changes constitutes acceptance of the updated terms.
          </p>

          <h2>Contact Information</h2>
          <p>If you have any questions about these Terms &amp; Conditions, please contact us at:</p>
          <ul>
            <li>
              Email: <a href="mailto:support@leadszora.com">support@leadszora.com</a>
            </li>
            <li>
              Company Name: <strong>Leadszora</strong>
            </li>
          </ul>
        </article>
      </main>

      <footer className="tos-footer">
        <div className="tos-footer__inner">
          <span>Copyright &copy; Leadszora 2026</span>
          <nav aria-label="Legal links">
            <a href="/">Home</a>
            <span>|</span>
            <a href="/2.0privacy-policy">Privacy Policy</a>
            <span>|</span>
            <a href="/2.0Terms-of-Service">Terms &amp; Conditions</a>
            <span>|</span>
            <a href="/2.0Earning-Disclaimer">Earning Disclaimer</a>
            <span>|</span>
            <a href="/2.0Contact-Us">Contact Us</a>
          </nav>
        </div>
      </footer>
    </div>
  )
}
